export default __webpack_public_path__ + "static/media/DSC_7454.074e16e7.jpg";